import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableFooter,
  Typography,
} from '@mui/material';

const widthValue = (col, columnWidth) => {
  return col.minWidth ? `${col.minWidth}px` : columnWidth;
};

const headerStyle = { position: 'sticky', top: '0', background: '#fff' };

const ReusableGrid = ({
  columns,
  rows,
  footer,
  minWidth = 650,
  withScroll = false,
}) => {
  const columnWidth = `${100 / (columns?.length || 1)}%`;

  return (
    <TableContainer component={Paper} sx={{ overflow: 'auto' }}>
      <Table sx={{ tableLayout: 'fixed', minWidth }}>
        <TableHead sx={withScroll && headerStyle}>
          <TableRow>
            {columns.map((col) => {
              const width = widthValue(col, columnWidth);
              return (
                <TableCell
                  key={col.field}
                  align={col.align || 'left'}
                  sx={{
                    whiteSpace: 'pre',
                    width: width,
                  }}
                >
                  {col.headerName}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={row.id || rowIndex}>
              {columns.map((col) => {
                // const width = col.minWidth ? `${col.minWidth}px` : columnWidth;
                return (
                  <TableCell
                    key={col.field}
                    align={col.align || 'left'}
                    sx={{
                      whiteSpace: 'nowrap',
                      width: widthValue(col, columnWidth),
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {col.renderCell
                      ? col.renderCell(row[col.field], row)
                      : row[col.field]}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
        {footer && (
          <TableFooter>
            <TableRow>
              {footer.map((value, index) => (
                <TableCell
                  key={index}
                  align={columns[index]?.align || 'left'}
                  sx={{ whiteSpace: 'nowrap', width: columnWidth }}
                >
                  <Typography fontWeight={600}>{value}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableFooter>
        )}
      </Table>
    </TableContainer>
  );
};

export default React.memo(ReusableGrid);
